import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const creditFilters: (
  creditTemplateNamesOptions: { label: string; value: string }[],
  creditTypeOptions: { label: string; value: string }[],
  creditTemplateOptions: { label: string; value: string }[],
) => (DefaultFilters | WithOptionsFilterFilters | ArrayFilters)[] = (
  creditTemplateNamesOptions,
  creditTypeOptions,
  creditTemplateOptions,
) => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'nickLike',
    label: '닉네임',
    placeholder: '닉네임를 입력해주세요',
  },
  {
    key: 'subDescription',
    label: '하위 카테고리',
    placeholder: '전체',
    options: creditTemplateOptions,
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'createdAt',
    label: '조회 기간',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'category',
    label: '상위 카테고리',
    placeholder: '전체',
    options: creditTemplateNamesOptions,
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'type',
    label: '타입',
    placeholder: '전체',
    options: creditTypeOptions,
    type: ListFilterTypeObject.SELECT,
  },
];
